import { defineComponent, computed, ref, createElementBlock, openBlock, createElementVNode, createCommentVNode, toDisplayString, unref, createTextVNode, Fragment, renderList, normalizeClass } from "vue";
import { dateFormatter, vatExemptNote, OrderItem, PaymentTypeLabel, OrderFlagType, Money } from "app-core";
import { useI18n } from "vue-i18n";
import { useUtilities } from "./index52.js";
import moment from "moment-timezone";
const _hoisted_1 = { class: "receipt-invoice-ba printable-area" };
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = {
  key: 1,
  class: "receipt-header"
};
const _hoisted_4 = { key: 0 };
const _hoisted_5 = { class: "receipt-subheader" };
const _hoisted_6 = { class: "receipt-details" };
const _hoisted_7 = { key: 0 };
const _hoisted_8 = { key: 1 };
const _hoisted_9 = { key: 2 };
const _hoisted_10 = { key: 3 };
const _hoisted_11 = { key: 4 };
const _hoisted_12 = { key: 5 };
const _hoisted_13 = { key: 6 };
const _hoisted_14 = { key: 7 };
const _hoisted_15 = { key: 8 };
const _hoisted_16 = { key: 9 };
const _hoisted_17 = {
  key: 0,
  class: "receipt-buyer"
};
const _hoisted_18 = { key: 0 };
const _hoisted_19 = { key: 1 };
const _hoisted_20 = { key: 2 };
const _hoisted_21 = { key: 3 };
const _hoisted_22 = { key: 4 };
const _hoisted_23 = { key: 5 };
const _hoisted_24 = { key: 6 };
const _hoisted_25 = { key: 7 };
const _hoisted_26 = {
  key: 2,
  class: "receipt-period"
};
const _hoisted_27 = { class: "receipt-items" };
const _hoisted_28 = {
  key: 0,
  class: "heading-row"
};
const _hoisted_29 = { align: "left" };
const _hoisted_30 = { align: "left" };
const _hoisted_31 = {
  align: "left",
  class: "name"
};
const _hoisted_32 = { align: "right" };
const _hoisted_33 = { align: "right" };
const _hoisted_34 = { align: "right" };
const _hoisted_35 = { align: "right" };
const _hoisted_36 = { align: "right" };
const _hoisted_37 = { align: "right" };
const _hoisted_38 = { align: "right" };
const _hoisted_39 = { align: "right" };
const _hoisted_40 = { align: "right" };
const _hoisted_41 = { align: "left" };
const _hoisted_42 = { align: "left" };
const _hoisted_43 = {
  align: "left",
  class: "name"
};
const _hoisted_44 = { align: "right" };
const _hoisted_45 = { align: "right" };
const _hoisted_46 = { align: "right" };
const _hoisted_47 = { align: "right" };
const _hoisted_48 = { align: "right" };
const _hoisted_49 = { align: "right" };
const _hoisted_50 = { align: "right" };
const _hoisted_51 = { align: "right" };
const _hoisted_52 = { align: "right" };
const _hoisted_53 = { colspan: "10" };
const _hoisted_54 = ["innerHTML"];
const _hoisted_55 = { class: "heading-row" };
const _hoisted_56 = { colspan: 11 };
const _hoisted_57 = { align: "right" };
const _hoisted_58 = { colspan: 11 };
const _hoisted_59 = { align: "right" };
const _hoisted_60 = { class: "receipt-footer" };
const _hoisted_61 = { class: "footer-item additional-info" };
const _hoisted_62 = { key: 0 };
const _hoisted_63 = {
  key: 1,
  class: "note"
};
const _hoisted_64 = {
  key: 2,
  class: "note"
};
const _hoisted_65 = { class: "signatures" };
const _hoisted_66 = { class: "signature" };
const _hoisted_67 = { class: "signature" };
const _hoisted_68 = { class: "footer-item summary" };
const _hoisted_69 = {
  key: 0,
  class: "summary-item"
};
const _hoisted_70 = { class: "amount" };
const _hoisted_71 = {
  key: 0,
  class: "divider",
  style: { "margin": "5px 0" }
};
const _hoisted_72 = {
  key: 1,
  class: "summary-item"
};
const _hoisted_73 = { class: "amount" };
const _hoisted_74 = {
  key: 2,
  class: "summary-item"
};
const _hoisted_75 = { class: "amount" };
const _hoisted_76 = { class: "summary-item" };
const _hoisted_77 = { class: "amount" };
const _hoisted_78 = {
  key: 3,
  class: "summary-item"
};
const _hoisted_79 = { class: "amount" };
const _hoisted_80 = { class: "summary-item" };
const _hoisted_81 = { class: "amount" };
const _hoisted_82 = {
  key: 4,
  class: "summary-item to-pay"
};
const _hoisted_83 = { class: "amount" };
const _hoisted_84 = { class: "amount" };
const priceFormat = "0.00";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ReceiptInvoiceLocalizationBa",
  props: {
    order: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      default: () => {
      }
    },
    venue: {
      type: Object,
      default: () => void 0
    },
    isRetail: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const { t } = useI18n();
    const { formatDate, formatDateTime } = dateFormatter();
    const { nl2br } = useUtilities();
    const props = __props;
    const vatNote = computed(() => vatExemptNote(props.venue, `${t("general.note")}: ${t("order.exempt_from_tax_comment")}`));
    const client = ref(props.order.getClient() || props.order.client || null);
    const productItems = ref(getProductItems());
    function getProductItems() {
      if (props.order.isSummary()) {
        return props.order.paysForOrders() ? OrderItem.merge(props.order.paysForOrders().flatMap((order) => order.items), props.order) : [];
      }
      return props.order.items;
    }
    const receiptItems = ref(props.order.isSummary() ? props.order.items : []);
    const taxes = ref(props.order.taxes.filter((taxItem) => !!taxItem.id || !taxItem.id && taxItem.label.includes("VAT_")));
    const summary = ref(getSummary());
    function getSummary() {
      return {
        exemptFromTax: props.order.getExemptFromTax(),
        priceBeforeTax: props.order.getPriceBeforeTax(),
        price: props.order.getPrice(),
        discountAmount: props.order.getDiscountAmount(),
        toPay: props.order.getToPay()
      };
    }
    const paymentTypes = ref(getPaymentTypes());
    function getPaymentTypes() {
      let allPaymentTypes = [];
      let paymentTypes2 = props.order.getPayments();
      const advancePayment = paymentTypes2.find((p) => p.key === PaymentTypeLabel.advance);
      if (advancePayment) {
        allPaymentTypes.push(advancePayment);
        paymentTypes2 = paymentTypes2.filter((p) => p.key !== PaymentTypeLabel.advance);
      }
      allPaymentTypes = [
        ...allPaymentTypes,
        ...paymentTypes2.filter((p) => p.key !== PaymentTypeLabel.advance)
      ];
      return allPaymentTypes;
    }
    return (_ctx, _cache) => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i;
      return openBlock(), createElementBlock("div", _hoisted_1, [
        ((_a = __props.venue) == null ? void 0 : _a.invoice_header) ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "ck-content ck-custom",
          innerHTML: (_b = __props.venue) == null ? void 0 : _b.invoice_header
        }, null, 8, _hoisted_2)) : (openBlock(), createElementBlock("div", _hoisted_3, [
          createElementVNode("p", null, toDisplayString((_c = __props.venue) == null ? void 0 : _c.company_name), 1),
          createElementVNode("p", null, toDisplayString((_d = __props.venue) == null ? void 0 : _d.name), 1),
          ((_e = __props.venue) == null ? void 0 : _e.tax_id_number) ? (openBlock(), createElementBlock("p", _hoisted_4, toDisplayString(unref(t)("general.tax_id_number") + ": " + ((_f = __props.venue) == null ? void 0 : _f.tax_id_number)), 1)) : createCommentVNode("", true),
          createElementVNode("p", null, toDisplayString((_g = __props.venue) == null ? void 0 : _g.address), 1)
        ])),
        createElementVNode("div", _hoisted_5, [
          createElementVNode("div", _hoisted_6, [
            __props.order.internal_number ? (openBlock(), createElementBlock("p", _hoisted_7, toDisplayString(`${!__props.order.isProforma() ? unref(t)("invoice.number") : unref(t)("invoice.proforma.number")}: ${__props.order.internal_number}`), 1)) : createCommentVNode("", true),
            __props.order.number ? (openBlock(), createElementBlock("p", _hoisted_8, toDisplayString(unref(t)("general.receipt_number_serial") + ": " + __props.order.number), 1)) : createCommentVNode("", true),
            __props.order.getUser() ? (openBlock(), createElementBlock("p", _hoisted_9, toDisplayString(unref(t)("general.operator") + ": " + ((_h = __props.order.getUser()) == null ? void 0 : _h.name) + " / " + ((_i = __props.order.getUser()) == null ? void 0 : _i.hash)), 1)) : createCommentVNode("", true),
            __props.order.getLastActivityAt() ? (openBlock(), createElementBlock("p", _hoisted_10, toDisplayString(unref(t)("general.issued_at") + ": ") + " " + toDisplayString(unref(formatDateTime)(__props.order.getLastActivityAt() || unref(moment)())), 1)) : createCommentVNode("", true),
            __props.order.getTransactionDate() ? (openBlock(), createElementBlock("p", _hoisted_11, toDisplayString(unref(t)("general.transaction_date") + ": ") + " " + toDisplayString(unref(formatDate)(__props.order.getTransactionDate())), 1)) : createCommentVNode("", true),
            __props.order.paymentType() && !__props.order.isProforma() ? (openBlock(), createElementBlock("p", _hoisted_12, toDisplayString(unref(t)("general.paid_by") + ": " + __props.order.paymentType()), 1)) : createCommentVNode("", true),
            __props.order.isSummary() ? (openBlock(), createElementBlock("p", _hoisted_13, toDisplayString(unref(t)("general.receipt_type") + ": " + unref(t)("general.receipt_summary")), 1)) : createCommentVNode("", true),
            __props.order.isAdvance() ? (openBlock(), createElementBlock("p", _hoisted_14, toDisplayString(unref(t)("general.receipt_type") + ": " + unref(t)("general.advance")), 1)) : createCommentVNode("", true),
            __props.order.due_date ? (openBlock(), createElementBlock("p", _hoisted_15, toDisplayString(!__props.order.isAdvance() ? unref(t)("general.due_date") : unref(t)("general.paid_date_advance")) + ": " + toDisplayString(unref(formatDate)(__props.order.due_date)), 1)) : createCommentVNode("", true),
            __props.order.tax_period ? (openBlock(), createElementBlock("p", _hoisted_16, toDisplayString(unref(t)("general.tax_period")) + ": " + toDisplayString(__props.order.tax_period), 1)) : createCommentVNode("", true)
          ]),
          client.value ? (openBlock(), createElementBlock("div", _hoisted_17, [
            createElementVNode("p", null, [
              createElementVNode("strong", null, toDisplayString(unref(t)("general.buyer", 1)), 1)
            ]),
            client.value.name ? (openBlock(), createElementBlock("p", _hoisted_18, toDisplayString(client.value.name), 1)) : createCommentVNode("", true),
            client.value.cost_center ? (openBlock(), createElementBlock("p", _hoisted_19, toDisplayString(unref(t)("general.buyer_cost_center") + ": " + client.value.cost_center), 1)) : createCommentVNode("", true),
            client.value.address ? (openBlock(), createElementBlock("p", _hoisted_20, [
              createTextVNode(toDisplayString(`${client.value.address}`) + " ", 1),
              client.value.city ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                createTextVNode(", " + toDisplayString(`${client.value.city}`), 1)
              ], 64)) : createCommentVNode("", true),
              client.value.country ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                createTextVNode(", " + toDisplayString(`${client.value.country}`), 1)
              ], 64)) : createCommentVNode("", true)
            ])) : createCommentVNode("", true),
            client.value.id_number ? (openBlock(), createElementBlock("p", _hoisted_21, toDisplayString(unref(t)(`clients.id_types.${client.value.id_type}`) + ": " + client.value.id_number), 1)) : createCommentVNode("", true),
            client.value.tax_id_number && client.value.tax_id_number !== client.value.id_number ? (openBlock(), createElementBlock("p", _hoisted_22, toDisplayString(unref(t)("general.tax_id_number") + ": " + client.value.tax_id_number), 1)) : createCommentVNode("", true),
            client.value.registration_number ? (openBlock(), createElementBlock("p", _hoisted_23, toDisplayString(unref(t)("general.registration_number") + ": " + client.value.registration_number), 1)) : createCommentVNode("", true),
            client.value.tax_id_card_number ? (openBlock(), createElementBlock("p", _hoisted_24, toDisplayString(unref(t)("general.tax_id_card_number") + ": " + client.value.tax_id_card_number), 1)) : createCommentVNode("", true),
            client.value.vat_number ? (openBlock(), createElementBlock("p", _hoisted_25, toDisplayString(unref(t)("general.vat_number_short") + ": " + client.value.vat_number), 1)) : createCommentVNode("", true)
          ])) : createCommentVNode("", true)
        ]),
        __props.order.start_date && __props.order.end_date ? (openBlock(), createElementBlock("div", _hoisted_26, toDisplayString(unref(t)("invoice.period")) + ": " + toDisplayString(unref(formatDate)(__props.order.start_date)) + " - " + toDisplayString(unref(formatDate)(__props.order.end_date)), 1)) : createCommentVNode("", true),
        createElementVNode("table", _hoisted_27, [
          createElementVNode("tbody", null, [
            productItems.value.length ? (openBlock(), createElementBlock("tr", _hoisted_28, [
              createElementVNode("td", _hoisted_29, toDisplayString(unref(t)("general.number_short")), 1),
              createElementVNode("td", _hoisted_30, toDisplayString(unref(t)("general.code")), 1),
              createElementVNode("td", _hoisted_31, toDisplayString(unref(t)("general.item", 1)), 1),
              createElementVNode("td", _hoisted_32, toDisplayString(unref(t)("invoice_preview.quantity")), 1),
              createElementVNode("td", _hoisted_33, toDisplayString(unref(t)("invoice_preview.unit_price_before_tax")), 1),
              createElementVNode("td", _hoisted_34, toDisplayString(unref(t)("invoice_preview.tax_rate")), 1),
              createElementVNode("td", _hoisted_35, toDisplayString(unref(t)("invoice_preview.unit_price")), 1),
              createElementVNode("td", _hoisted_36, toDisplayString(unref(t)("invoice_preview.discount")), 1),
              createElementVNode("td", _hoisted_37, toDisplayString(unref(t)("invoice_preview.unit_price_after_discount")), 1),
              createElementVNode("td", _hoisted_38, toDisplayString(unref(t)("invoice_preview.price_before_tax")), 1),
              createElementVNode("td", _hoisted_39, toDisplayString(unref(t)("invoice_preview.tax")), 1),
              createElementVNode("td", _hoisted_40, toDisplayString(unref(t)("invoice_preview.to_pay")), 1)
            ])) : createCommentVNode("", true),
            (openBlock(true), createElementBlock(Fragment, null, renderList(productItems.value, (item, index) => {
              var _a2, _b2;
              return openBlock(), createElementBlock(Fragment, {
                key: `invoice-${index}`
              }, [
                createElementVNode("tr", {
                  class: normalizeClass({ "border-bottom": (!__props.isRetail || !item.comments.length) && index != productItems.value.length - 1 })
                }, [
                  createElementVNode("td", _hoisted_41, toDisplayString(index + 1) + ".", 1),
                  createElementVNode("td", _hoisted_42, toDisplayString(((_a2 = item.getProduct()) == null ? void 0 : _a2.code) || ""), 1),
                  createElementVNode("td", _hoisted_43, toDisplayString(item.name), 1),
                  createElementVNode("td", _hoisted_44, [
                    createTextVNode(toDisplayString(item.getCount()) + " ", 1),
                    createElementVNode("small", null, toDisplayString(((_b2 = item.getProduct()) == null ? void 0 : _b2.getUnitOfMeasureSold()) || ""), 1)
                  ]),
                  createElementVNode("td", _hoisted_45, toDisplayString(item.getUnitPriceBeforeTax().toFormat("0.0000")), 1),
                  createElementVNode("td", _hoisted_46, toDisplayString(item.getTaxRate()) + "%", 1),
                  createElementVNode("td", _hoisted_47, toDisplayString(item.getUnitPriceAfterTax().toFormat(priceFormat)), 1),
                  createElementVNode("td", _hoisted_48, toDisplayString(item.getDiscountPercent()) + "%", 1),
                  createElementVNode("td", _hoisted_49, toDisplayString(item.getUnitPriceAfterDiscount().toFormat(priceFormat)), 1),
                  createElementVNode("td", _hoisted_50, toDisplayString(item.getPriceBeforeTax().toFormat(priceFormat)), 1),
                  createElementVNode("td", _hoisted_51, toDisplayString(item.getTax().toFormat(priceFormat)), 1),
                  createElementVNode("td", _hoisted_52, toDisplayString(item.getToPay().toFormat(priceFormat)), 1)
                ], 2),
                __props.isRetail && item.comments.length ? (openBlock(), createElementBlock("tr", {
                  key: `invoice-item-comment-${index}`,
                  class: normalizeClass({ "border-bottom": index != productItems.value.length - 1 })
                }, [
                  _cache[0] || (_cache[0] = createElementVNode("td", null, null, -1)),
                  _cache[1] || (_cache[1] = createElementVNode("td", null, null, -1)),
                  createElementVNode("td", _hoisted_53, [
                    createElementVNode("span", {
                      style: { "font-size": "11px" },
                      innerHTML: unref(nl2br)(item.comments[0])
                    }, null, 8, _hoisted_54)
                  ])
                ], 2)) : createCommentVNode("", true)
              ], 64);
            }), 128)),
            receiptItems.value.length ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              createElementVNode("tr", _hoisted_55, [
                createElementVNode("td", _hoisted_56, toDisplayString(unref(t)("general.receipt", 1)), 1),
                createElementVNode("td", _hoisted_57, toDisplayString(unref(t)("general.price")), 1)
              ]),
              (openBlock(true), createElementBlock(Fragment, null, renderList(receiptItems.value, (item, index) => {
                return openBlock(), createElementBlock("tr", {
                  key: `receipt-${index}`
                }, [
                  createElementVNode("td", _hoisted_58, toDisplayString(item.name), 1),
                  createElementVNode("td", _hoisted_59, toDisplayString(item.getPrice().toFormat(priceFormat)), 1)
                ]);
              }), 128))
            ], 64)) : createCommentVNode("", true),
            _cache[2] || (_cache[2] = createElementVNode("tr", { class: "divider" }, [
              createElementVNode("td", { colspan: 12 })
            ], -1))
          ])
        ]),
        createElementVNode("div", _hoisted_60, [
          createElementVNode("div", _hoisted_61, [
            __props.order.getFlag(unref(OrderFlagType).roomCharge).length ? (openBlock(), createElementBlock("p", _hoisted_62, toDisplayString(unref(t)("integrations.room_charge.room_number")) + ": " + toDisplayString(__props.order.getFlag(unref(OrderFlagType).roomCharge)[0]), 1)) : createCommentVNode("", true),
            __props.order.note ? (openBlock(), createElementBlock("p", _hoisted_63, toDisplayString(__props.order.note), 1)) : createCommentVNode("", true),
            vatNote.value ? (openBlock(), createElementBlock("p", _hoisted_64, toDisplayString(vatNote.value), 1)) : createCommentVNode("", true),
            createElementVNode("div", _hoisted_65, [
              createElementVNode("div", _hoisted_66, [
                _cache[3] || (_cache[3] = createElementVNode("div", null, "___________________", -1)),
                createElementVNode("div", null, toDisplayString(unref(t)("invoice.delivered_by")), 1)
              ]),
              createElementVNode("div", _hoisted_67, [
                _cache[4] || (_cache[4] = createElementVNode("div", null, "___________________", -1)),
                createElementVNode("div", null, toDisplayString(unref(t)("invoice.received_by")), 1)
              ])
            ])
          ]),
          createElementVNode("div", _hoisted_68, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(taxes.value, (tax, index) => {
              return openBlock(), createElementBlock(Fragment, {
                key: "tx" + index
              }, [
                tax.id ? (openBlock(), createElementBlock("div", _hoisted_69, [
                  createElementVNode("p", null, toDisplayString(`${tax.label} (${tax.rate}%):`), 1),
                  createElementVNode("p", _hoisted_70, toDisplayString(unref(Money).parse(tax.value).toFormat(priceFormat)), 1)
                ])) : createCommentVNode("", true)
              ], 64);
            }), 128)),
            taxes.value.length ? (openBlock(), createElementBlock("div", _hoisted_71)) : createCommentVNode("", true),
            summary.value.exemptFromTax && summary.value.exemptFromTax.toUnit() > 0 ? (openBlock(), createElementBlock("div", _hoisted_72, [
              createElementVNode("p", null, toDisplayString(unref(t)("invoice_preview.summary.exempt_from_tax")) + ":", 1),
              createElementVNode("p", _hoisted_73, toDisplayString(summary.value.exemptFromTax.toFormat(priceFormat)), 1)
            ])) : createCommentVNode("", true),
            summary.value.priceBeforeTax ? (openBlock(), createElementBlock("div", _hoisted_74, [
              createElementVNode("p", null, toDisplayString(unref(t)("invoice_preview.summary.price_before_tax")) + ":", 1),
              createElementVNode("p", _hoisted_75, toDisplayString(summary.value.priceBeforeTax.toFormat(priceFormat)), 1)
            ])) : createCommentVNode("", true),
            createElementVNode("div", _hoisted_76, [
              createElementVNode("p", null, toDisplayString(unref(t)("invoice_preview.summary.tax")) + ":", 1),
              createElementVNode("p", _hoisted_77, toDisplayString(__props.order.getTax().toFormat(priceFormat)), 1)
            ]),
            _cache[5] || (_cache[5] = createElementVNode("div", {
              class: "divider",
              style: { "margin": "5px 0" }
            }, null, -1)),
            summary.value.price ? (openBlock(), createElementBlock("div", _hoisted_78, [
              createElementVNode("p", null, toDisplayString(unref(t)("invoice_preview.summary.price_after_tax")) + ":", 1),
              createElementVNode("p", _hoisted_79, toDisplayString(summary.value.price.toFormat(priceFormat)), 1)
            ])) : createCommentVNode("", true),
            createElementVNode("div", _hoisted_80, [
              createElementVNode("p", null, toDisplayString(unref(t)("invoice_preview.summary.discount")) + ":", 1),
              createElementVNode("p", _hoisted_81, toDisplayString(summary.value.discountAmount.toFormat(priceFormat)), 1)
            ]),
            _cache[6] || (_cache[6] = createElementVNode("div", {
              class: "divider",
              style: { "margin": "5px 0" }
            }, null, -1)),
            summary.value.toPay ? (openBlock(), createElementBlock("div", _hoisted_82, [
              createElementVNode("p", null, toDisplayString(unref(t)("invoice_preview.summary.to_pay")) + ":", 1),
              createElementVNode("p", _hoisted_83, toDisplayString(summary.value.toPay.toFormat()), 1)
            ])) : createCommentVNode("", true),
            (openBlock(true), createElementBlock(Fragment, null, renderList(paymentTypes.value, (paymentType, index) => {
              return openBlock(), createElementBlock("div", {
                key: "ptl" + index,
                class: "summary-item"
              }, [
                createElementVNode("p", null, toDisplayString(paymentType.display) + ":", 1),
                createElementVNode("p", _hoisted_84, toDisplayString(unref(Money).parse(paymentType.amount).toFormat()), 1)
              ]);
            }), 128))
          ])
        ])
      ]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=index22.js.map
